// Commerce step names and the labels built from them. See
// docs/features/2026.10.09-static-string-consolidation/decisions/2026.10.09-001-static-copy-data-objects.md
export const commerceStepsContent = {
  // Step names (long name in headers, short name in the step nav)
  galleryStepName: 'Gallery',
  yearbookStepLongName: 'Select Yearbook Photo',
  yearbookStepShortName: 'Yearbook',
  selectPosesStepLongName: 'Select Your Poses',
  selectPosesStepShortName: 'Select Poses',
  // Underclass replaces Select Poses with this step
  customizeOrderStepLongName: 'Customize Your Order',
  customizeOrderStepShortName: 'Customize Order',
  retouchingStepName: 'Retouching',
  checkoutStepLongName: "Let's Check Out",
  checkoutStepShortName: 'Checkout',
  packageBuilderStepName: 'Customize Package',
  // Senior preorder relabels the Gallery step
  preorderGalleryStepNameTemplate: 'Order for ##SubjectName##',

  // Labels
  nextStepLabelTemplate: 'Next: ##StepName##',
  stepNumberLabelTemplate: 'Step ##Number##:',
  stepCounterLabelTemplate: 'Step ##Current## / ##Total##'
}
